// import RulePack from './RulePack';

export default {
  priority: 35,
  path: "packet",
  permissions: ["Salary/SalaryCalculateMenu"],
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./SalaryFactor")
  ),
  name: app.translate("ضرایب  حقوق و دستمزد"),
  icon: "content-paste",
  drawer: true,
};
